import { cache } from "react";
import type { CountryType, Nullable } from "../../../@types/generic";
import { fetcher } from "../index";
import type { SearchResult } from "../types/search";

export const getAutosuggestSearch = cache(
    async (
        searchTerm: string,
        country: CountryType
    ): Promise<Nullable<SearchResult>> =>
        fetcher<SearchResult>(
            { path: `/search/autosuggest/${searchTerm}/` },
            { country }
        )
            .then((response) => response.data)
            .catch(() => null)
);
